export default "__VITE_ASSET__58bd9781__"